export class AppConstants {
    static TAG_NAME: string = "vk";
}

declare global {
  interface Console {
    style: string;
  }
}
/*
const originalLog = console.log;
console.log = function(msg, style, ...args) {
  if ( console.style ){
    originalLog("%c"+msg, style, ...args);
  }else{
    originalLog(...args);
  }  
};
*/